// extracted by mini-css-extract-plugin
module.exports = {"TransformContainer":"TransformContainer_TransformContainer__OfdXH"};